module.exports = __webpack_public_path__ + "static/media/profile-thumb.5ed19794.jpg";